module.exports = __webpack_public_path__ + "static/Manrope-ExtraBold-47e356f61dca7aa2dfba5593e000c4f1.ttf";